import { render, staticRenderFns } from "./templateCreateModuleForm.vue?vue&type=template&id=c1b33c4a&"
import script from "./templateCreateModuleForm.vue?vue&type=script&lang=ts&"
export * from "./templateCreateModuleForm.vue?vue&type=script&lang=ts&"
import style0 from "./templateCreateModuleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports